import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class SeeMoreController extends Controller {
  static targets = [
    'hintText',
    'fullText',
    'seeMoreLink',
    'seeLessLink',
  ];

  connect() {
    useEventListener(this, this.seeMoreLinkTarget, 'click', this.seeMore);
    useEventListener(this, this.seeLessLinkTarget, 'click', this.seeLess);
  }

  seeMore() {
    this.hintTextTarget.classList.add('hidden');
    this.fullTextTarget.classList.remove('hidden');
    this.seeMoreLinkTarget.classList.add('hidden');
    this.seeLessLinkTarget.classList.remove('hidden');
  }

  seeLess() {
    this.hintTextTarget.classList.remove('hidden');
    this.fullTextTarget.classList.add('hidden');
    this.seeMoreLinkTarget.classList.remove('hidden');
    this.seeLessLinkTarget.classList.add('hidden');
  }
}
